module.exports = __webpack_public_path__ + "static/logo-e8fe55cb20b6272623519dfa6e54873e.png";